module.exports = __webpack_public_path__ + "static/pic11-c5884c4b94a6c0488e87878af0a1a597.jpeg";